import { render, staticRenderFns } from "./DoubleImageLabel.vue?vue&type=template&id=c5012b62&"
import script from "./DoubleImageLabel.vue?vue&type=script&lang=js&"
export * from "./DoubleImageLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports